"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
/**
 * 모달, 패널, 시트 등 레이어를 닫는 버튼.
 */
let CloseButton = class CloseButton extends (0, icon_button_utils_1.iconActionElement)({
    event: 'close',
    icon: icon_names_1.ICON_NAMES.CLOSE,
    ariaLabel: '닫기',
}) {
};
CloseButton = __decorate([
    (0, decorators_js_1.customElement)('mm-close-button')
], CloseButton);
exports.CloseButton = CloseButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xvc2UtYnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY2xvc2UtYnV0dG9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLHFEQUFpRDtBQUVqRCxvRUFBZ0U7QUFDaEUseUZBQXFGO0FBRXJGOztHQUVHO0FBRUksSUFBTSxXQUFXLEdBQWpCLE1BQU0sV0FBWSxTQUFRLElBQUEscUNBQWlCLEVBQUM7SUFDakQsS0FBSyxFQUFFLE9BQU87SUFDZCxJQUFJLEVBQUUsdUJBQVUsQ0FBQyxLQUFLO0lBQ3RCLFNBQVMsRUFBRSxJQUFJO0NBQ2hCLENBQUM7Q0FBRyxDQUFBO0FBSlEsV0FBVztJQUR2QixJQUFBLDZCQUFhLEVBQUMsaUJBQWlCLENBQUM7R0FDcEIsV0FBVyxDQUluQjtBQUpRLGtDQUFXIn0=